import { twMerge } from "tailwind-merge";
import { motion } from "motion/react";
import { Helmet } from "react-helmet-async";
import { Loader } from "@shared/ui/Loader";
import { PlatformAppFooter } from "./PlatformAppFooter";
import { SupportArticleSheetContainer } from "../features/support/components/SupportArticleSheet/SupportArticleSheetContainer";
import { SupportDialogs } from "../features/support/components/SupportDialogs/SupportDialogs";
import { MarketingDialogs } from "../features/marketing/components/MarketingDialogs/MarketingDialogs";
import { ChatSheetContainer } from "../features/chat/components/ChatSheet/ChatSheetContainer";

export type Props = {
  children?: React.ReactNode;
  className?: string;
  header?: React.ReactNode;
  isWithFooter?: boolean;
  title: string;
  isLoading?: boolean;
};

export function AppLayout({
  children,
  className,
  header,
  isLoading,
  isWithFooter = true,
  title,
}: Props) {
  return (
    <>
      <Helmet>
        <title>{["Pollinator", title].filter(Boolean).join(" | ")}</title>
      </Helmet>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3, ease: "easeIn" }}
      >
        <div className="min-h-[100dvh] flex flex-col bg-brand-50 text-brand-800">
          {header}
          <main className={twMerge("flex-grow flex flex-col", className)}>
            {isLoading ? <Loader /> : children}
          </main>
          {isWithFooter && <PlatformAppFooter />}
        </div>

        <MarketingDialogs />
        <SupportArticleSheetContainer />
        <SupportDialogs />
        <ChatSheetContainer />
      </motion.div>
    </>
  );
}

export default AppLayout;
